<template>
    <div class="no_data" >         
        <!--<figure v-if="dtype !='files'"><img src="@/assets/images/no_data.svg"></figure>
        <figure v-if="dtype =='files'"> <img src="@/assets/images/no-documents.svg"></figure>-->
        <p v-if="dtype !=''">No {{ dtype }} were found.</p>
        <p v-if="dtype ==''">No result were found.</p>
    </div>
</template>


<script>
 

export default {
  data () {
    return {
        
    }
    
  },
  props:{
    dtype:{ 
      type:String,
      default:''
    }
  },
  mounted () {
    //this.dtype ='';
  }
    
}
</script>